<template>
  <ElButton
    tag="a"
    type="primary"
    size="small"
    class="ui-btn1 telegram-button"
    :disabled="isDisabled"
    :href="link"
    target="_blank"
  >
    <ElIcon>
      <TelegramIcon />
    </ElIcon>
    {{ t('btnWriteToTelegramBot') }}
  </ElButton>
</template>

<script setup lang="ts">
import { computed, ref, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { ElButton, ElIcon } from 'element-plus';

import TelegramIcon from '@/components/icons/Telegram.vue';

const ENABLE_BUTTON_DELAY = 3000;

const { t } = useI18n();

const props = defineProps<{
  username: string;
}>();

const hasInteracted = ref(false);
const isDelayPassed = ref(false);

const link = computed(() => (isDisabled.value ? '#' : `https://t.me/${props.username}`));
const isDisabled = computed(() => !hasInteracted.value || !isDelayPassed.value);

const markInteraction = () => {
  hasInteracted.value = true;
  removeEventListeners();
};

const removeEventListeners = () => {
  window.removeEventListener('mousemove', markInteraction);
  window.removeEventListener('scroll', markInteraction);
  window.removeEventListener('keydown', markInteraction);
  window.removeEventListener('touchstart', markInteraction);
};

onMounted(() => {
  setTimeout(() => {
    isDelayPassed.value = true;
    removeEventListeners();
  }, ENABLE_BUTTON_DELAY);

  window.addEventListener('mousemove', markInteraction, { once: true });
  window.addEventListener('scroll', markInteraction, { once: true });
  window.addEventListener('keydown', markInteraction, { once: true });
  window.addEventListener('touchstart', markInteraction, { once: true });
});

onUnmounted(() => {
  removeEventListeners();
});
</script>

<style lang="scss">
.telegram-button {
  padding: 4px 6px;

  span {
    gap: 4px;
  }
}
</style>
